import { render, staticRenderFns } from "./formulario_novo.vue?vue&type=template&id=686796ab"
import script from "./formulario_novo.vue?vue&type=script&lang=js"
export * from "./formulario_novo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports